import { createIcon } from "@chakra-ui/icons";

// Created from ogc.svg

export const OGCIcon = createIcon({
  displayName: "OGC 3D Tiles",
  viewBox: "0 0 27 27",
  path: (
    <g>
      <path
        d="M13.0374 0L24.8749 3.54323L13.0374 9.04307L1.25001 3.54324L13.0374 0Z"
        fill="#69A0C9"
      />
      <path d="M13.75 10.1202L26.125 4.24473V18.4947L13.75 26.3697V10.1202Z" fill="#69A0C9" />
      <path d="M12.375 10.1202L0 4.24473V18.4947L12.375 26.3697V10.1202Z" fill="#69A0C9" />
    </g>
  ),
});
